import type { ComponentProps } from 'react';
import { cn } from '../../lib/cn.js';

/**
 * Form controls, shadcn shape and §5 tokens.
 *
 * `text-base` is not a style choice: iOS Safari zooms the page whenever a
 * focused input's font is under 16px, and a checkout that jumps every time the
 * customer taps a field is a checkout they abandon.
 */
const base =
  'w-full rounded-[var(--radius)] border border-[var(--color-border)] bg-[var(--color-bg)] ' +
  'px-3 py-2.5 text-base min-h-11 text-[var(--color-text)] ' +
  'placeholder:text-[var(--color-text-muted)] ' +
  'focus-visible:outline-2 focus-visible:outline-offset-[-1px] focus-visible:outline-[var(--color-primary)] ' +
  'disabled:opacity-50';

export function Input({ className, ...props }: ComponentProps<'input'>) {
  return <input data-slot="input" className={cn(base, className)} {...props} />;
}

export function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return <textarea data-slot="textarea" className={cn(base, 'min-h-16', className)} {...props} />;
}

/**
 * The native `<select>`, deliberately.
 *
 * A Radix listbox would be a popover this app has to render, position and
 * translate; the platform control is a wheel the OS already draws in the
 * customer's own language. On the mid-range Android §7 budgets for, native
 * wins on every axis that matters here.
 */
export function Select({ className, ...props }: ComponentProps<'select'>) {
  return <select data-slot="select" className={cn(base, 'pr-9', className)} {...props} />;
}
